export default "__VITE_ASSET__BrATGGp7__"